<!-- Start Page Header -->
<div class="page-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="entry-title">{{'contact' | translate}}</h2>
                <div class="breadcrumb">
                    <span>{{'here' | translate}} : </span>
                    <a routerLink="/Home">{{'home' | translate}}</a>
                    <span class="crumbs-spacer"><i class="fa fa-angle-double-right"></i></span>
                    <span class="current">{{'contact' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Header -->

<!-- Start Content Section -->
<section id="content">
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <h2 class="big-title">{{'ContactForm' | translate}}</h2>

                <!-- Start Contact Form -->
                <!-- Start Contact Form -->
                <form #contactForm="ngForm" id="contactForm" class="contact-form shake" novalidate
                    (ngSubmit)="sendMessage(contactForm)">
                    <!-- Name -->
                    <div class="form-group">
                        <div class="controls">
                            <input type="text" id="name" name="name" class="form-control"
                                placeholder="{{ 'Name' | translate }}" [(ngModel)]="contact.name" #name="ngModel"
                                required />

                            <div class="help-block with-errors"
                                *ngIf="name.invalid && (name.touched || contactForm.submitted)">
                                {{ 'nameRequired' | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="form-group">
                        <div class="controls">
                            <input type="email" id="email" name="email" class="email form-control"
                                placeholder="{{ 'Email' | translate }}" [(ngModel)]="contact.email" #email="ngModel"
                                required email />

                            <div class="help-block with-errors" *ngIf="email.errors?.['required'] &&
               (email.touched || contactForm.submitted)">
                                {{ 'emailRequired' | translate }}
                            </div>

                            <div class="help-block with-errors" *ngIf="email.errors?.['email'] &&
               (email.touched || contactForm.submitted)">
                                {{ 'invalidEmail' | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Mobile -->
                    <div class="form-group">
                        <div class="controls">
                            <input type="tel" id="msg_Mobile" name="mobile" class="form-control"
                                placeholder="{{ 'Mobile' | translate }}" [(ngModel)]="contact.mobile" #mobile="ngModel"
                                required minlength="10" maxlength="20" />

                            <div class="help-block with-errors" *ngIf="mobile.errors?.['required'] &&
               (mobile.touched || contactForm.submitted)">
                                {{ 'mobileRequired' | translate }}
                            </div>

                            <div class="help-block with-errors" *ngIf="mobile.errors?.['minlength'] &&
               (mobile.touched || contactForm.submitted)">
                                {{ 'mobileMinLength' | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Subject -->
                    <div class="form-group">
                        <div class="controls">
                            <input type="text" id="msg_subject" name="subject" class="form-control"
                                placeholder="{{ 'Subject' | translate }}" [(ngModel)]="contact.subject"
                                #subject="ngModel" required />

                            <div class="help-block with-errors" *ngIf="subject.invalid &&
               (subject.touched || contactForm.submitted)">
                                {{ 'subjectRequired' | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Message -->
                    <div class="form-group">
                        <div class="controls">
                            <textarea id="message" name="message" rows="7" class="form-control"
                                placeholder="{{ 'Massage' | translate }}" [(ngModel)]="contact.message"
                                #message="ngModel" required></textarea>

                            <div class="help-block with-errors" *ngIf="message.invalid &&
               (message.touched || contactForm.submitted)">
                                {{ 'messageRequired' | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Success message -->
                    <div class="alert alert-success" role="alert" *ngIf="successMessage">
                        {{ successMessage }}
                    </div>

                    <!-- Error message -->
                    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                        {{ errorMessage }}
                    </div>

                    <button type="submit" id="submit" class="btn btn-effect" [disabled]="isSending">
                        <i class="fa" [ngClass]="isSending ? 'fa-spinner fa-spin' : 'fa-check'"></i>

                        <span *ngIf="!isSending">
                            {{ 'SendMessage' | translate }}
                        </span>

                        <span *ngIf="isSending">
                            {{ 'sending' | translate }}
                        </span>
                    </button>

                    <div class="clearfix"></div>
                </form>
                <!-- End Contact Form -->
                <!-- End Contact Form -->

            </div>
            <div class="col-md-3">
                <h2 class="big-title">{{'Headquarters' | translate}}</h2>
                <div class="information">
                    <div class="contact-datails">
                        <p><i class="icon-pointer"></i> {{'address' | translate}}
                        </p>
                        <p><i class="icon-call-out"></i> +966-11-4501055</p>
                        <p><i class="icon-envelope"></i> admin@aldawal.com </p>
                        <p><i class="icon-clock"></i> {{'fullwork' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Content Section  -->

<!-- Start Map Section -->
<div class="map-area">
    <div class="map">
        <!-- <iframe src="https://aldawal.com/Location.html" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe> -->
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3046.9408136046136!2d46.70860821156625!3d24.74597198288316!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03ee7e45fedd%3A0x8490f6c733bae4dc!2z2LTYsdmD2Kkg2YbYuNmFINin2YTYr9mI2KfZhCDZhNiq2YLZhtmK2Kkg2KfZhNmF2LnZhNmI2YXYp9iq!5e0!3m2!1sar!2seg!4v1689587370732!5m2!1sar!2seg"
            width="100%" height="450" frameborder="0" style="border:0" allowfullscreen loading="lazy"></iframe>
    </div>
</div>